import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_INDICATOR_PRODUCTS_CALCULATION_PROGRESS_PATH,
  GetIndicatorProductsCalculationProgressErrorDto,
  GetIndicatorProductsCalculationProgressSuccessDto,
} from '@/api/rest/resources/types/IndicatorProduct';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';
import { assertIsDefined } from '@/utils/assert';

type SuccessDto = GetIndicatorProductsCalculationProgressSuccessDto;
type ErrorDto = GetIndicatorProductsCalculationProgressErrorDto;

export const useIndicatorProductCalcualtionProgress = (indicatorProductId: string, organizationIdArg?: string) => {
  const orgId = useOrganizationId();

  const organizationId = organizationIdArg ?? orgId;

  assertIsDefined(indicatorProductId, 'indicatorProductId');
  assertIsDefined(organizationId, 'organizationId');

  const queryParams = { organization_id: organizationId, indicator_product_id: indicatorProductId };

  const queryFn = async () => {
    return getRequest<SuccessDto>(GET_INDICATOR_PRODUCTS_CALCULATION_PROGRESS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['plots', 'organization', 'indicator-products-calculation-progress', queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
